import { FormGroupState } from 'ngrx-forms';
import { ValueRecognitionForm } from '../models/value-recognition-form.model';
import { ValueRecognitionTableInfos } from '../models/value-recognition-tables-info.model';

export function createValueRecognitionTablesInfo(
  valueRecognitionFormState: FormGroupState<ValueRecognitionForm>
): ValueRecognitionTableInfos {
  const phase2 = valueRecognitionFormState.controls.phase2.controls;
  const phase3 = valueRecognitionFormState.controls.phase3.controls;
  const phase4 = valueRecognitionFormState.controls.phase4.controls;

  const defaultLossesTableInfo = {
    rowsTitle: ['phase 2', 'phase 3', 'phase 4'],
    columnsTitle: ['low', 'med', 'high'],
    formControlState: [
      [phase2.lossesLow, phase2.lossesMed, phase2.lossesHigh],
      [phase3.lossesLow, phase3.lossesMed, phase3.lossesHigh],
      [phase4.lossesLow, phase4.lossesMed, phase4.lossesHigh],
    ],
  };
  const defaultMitigationCostTableInfo = {
    rowsTitle: ['phase 2', 'phase 3', 'phase 4'],
    columnsTitle: ['low', 'med', 'high'],
    formControlState: [
      [phase2.mitigationLow, phase2.mitigationMed, phase2.mitigationHigh],
      [phase3.mitigationLow, phase3.mitigationMed, phase3.mitigationHigh],
      [phase4.mitigationLow, phase4.mitigationMed, phase4.mitigationHigh],
    ],
  };
  const clarificationsTableInfo = {
    rowsTitle: ['phase 2', 'phase 3', 'phase 4'],
    columnsTitle: [''],
    formControlState: [
      [phase2.clarification],
      [phase3.clarification],
      [phase4.clarification],
    ],
  };
  const phase2UrgencyXVulnerabilityTableInfo = {
    rowsTitle: ['low', 'med', 'high'],
    columnsTitle: ['low (%)', 'med (%)', 'high (%)'],
    formControlState: [
      [
        phase2.lowUrgencyLowVulnerability,
        phase2.lowUrgencyMedVulnerability,
        phase2.lowUrgencyHighVulnerability,
      ],
      [
        phase2.medUrgencyLowVulnerability,
        phase2.medUrgencyMedVulnerability,
        phase2.medUrgencyHighVulnerability,
      ],
      [
        phase2.highUrgencyLowVulnerability,
        phase2.highUrgencyMedVulnerability,
        phase2.highUrgencyHighVulnerability,
      ],
    ],
  };
  const phase3UrgencyXVulnerabilityTableInfo = {
    rowsTitle: ['low', 'med', 'high'],
    columnsTitle: ['low (%)', 'med (%)', 'high (%)'],
    formControlState: [
      [
        phase3.lowUrgencyLowVulnerability,
        phase3.lowUrgencyMedVulnerability,
        phase3.lowUrgencyHighVulnerability,
      ],
      [
        phase3.medUrgencyLowVulnerability,
        phase3.medUrgencyMedVulnerability,
        phase3.medUrgencyHighVulnerability,
      ],
      [
        phase3.highUrgencyLowVulnerability,
        phase3.highUrgencyMedVulnerability,
        phase3.highUrgencyHighVulnerability,
      ],
    ],
  };
  const phase4UrgencyXVulnerabilityTableInfo = {
    rowsTitle: ['low', 'med', 'high'],
    columnsTitle: ['low (%)', 'med (%)', 'high (%)'],
    formControlState: [
      [
        phase4.lowUrgencyLowVulnerability,
        phase4.lowUrgencyMedVulnerability,
        phase4.lowUrgencyHighVulnerability,
      ],
      [
        phase4.medUrgencyLowVulnerability,
        phase4.medUrgencyMedVulnerability,
        phase4.medUrgencyHighVulnerability,
      ],
      [
        phase4.highUrgencyLowVulnerability,
        phase4.highUrgencyMedVulnerability,
        phase4.highUrgencyHighVulnerability,
      ],
    ],
  };

  return {
    defaultLossesTableInfo,
    defaultMitigationCostTableInfo,
    clarificationsTableInfo,
    phase2UrgencyXVulnerabilityTableInfo,
    phase3UrgencyXVulnerabilityTableInfo,
    phase4UrgencyXVulnerabilityTableInfo,
  };
}
